/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo } from "react";
import Link from "next/link";
import Image from "next/image";
import { useQuery, gql } from "@apollo/client";

const HAND_LINK_QUERY = gql`
  query HandLink($id: String!, $lang: String!) {
    item(path: $id, language: $lang) {
      ... on PageNavigationLink {
        id
        linkField: field(name: "Url") {
          jss
        }
      }
    }
  }
`;

const HAND_LINK_ID = "{560D40A5-53CD-449C-A667-0E36BD29353B}";

function restructureUrl(url: string, linktype: string): string {
  if (!url) return "";
  if (linktype === "internal") {
    const lowerUrl = url.toLowerCase();
    const modulesIndex = lowerUrl.indexOf("/modules");
    if (modulesIndex !== -1) return url.substring(modulesIndex);
    return "";
  }
  return url;
}

type HandLinkProps = {
  locale: string;
};

const HandLink = ({ locale }: HandLinkProps): JSX.Element | null => {
  const { data: handLinkData } = useQuery(HAND_LINK_QUERY, {
    variables: { id: HAND_LINK_ID, lang: locale || "ar" },
    skip: !locale,
  });

  const handLinkValue = handLinkData?.item?.linkField?.jss?.value;

  const handLink = useMemo(() => {
    if (!handLinkValue) return null;
    return {
      ...handLinkValue,
      href: restructureUrl(handLinkValue.href, handLinkValue.linktype) || "/",
      target: handLinkValue.target || "_self",
    };
  }, [handLinkValue]);

  if (!handLink?.href) return null;

  return (
    <nav
      aria-label={
        locale === "ar"
          ? "دعم إتاحة الوصول"
          : locale === "zh"
          ? "无障碍支持"
          : locale === "ko"
          ? "접근성 지원"
          : "Accessibility support"
      }
      className="fixed bottom-[107px] left-[6px] z-50 cursor-pointer"
    >
      <Link href={handLink.href} legacyBehavior>
        <a
          target={handLink.target}
          rel="noopener noreferrer"
          aria-label={locale === "ar" ? "رابط الدعم والمساعدة" : "Accessibility support link"}
        >
          <Image
            src="/Icons/hand.svg"
            width={50}
            height={50}
            alt=""
            aria-hidden={true}
          />
        </a>
      </Link>
    </nav>
  );
};

export default HandLink;
